import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef2cd752"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://gravatar.com/avatar/66b6ea280a135ce23cdc97a2eae0d50284710b6340eee3df8c5d3f86dc3d02bf?s=500",
  alt: "profile-photo",
  loading: "lazy"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Adrián Rey Brea", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "✉️"),
  /*#__PURE__*/_createTextVNode(" adrian@adrianrey.dev")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "📞"),
  /*#__PURE__*/_createTextVNode(" +34 644 92 25 48")
], -1))
const _hoisted_7 = { class: "links-text" }
const _hoisted_8 = { class: "rrss" }
const _hoisted_9 = {
  href: "https://www.linkedin.com/in/adrián-rey-brea-9657061b1",
  target: "_blank"
}
const _hoisted_10 = {
  href: "https://www.instagram.com/rey.code_",
  target: "_blank"
}
const _hoisted_11 = {
  href: "https://twitter.com/reycode_",
  target: "_blank"
}
const _hoisted_12 = {
  href: "https://wa.me/+34644922548?text=%C2%A1Hola%20Adri%C3%A1n%21%20He%20visto%20tu%20portfolio%20online%20en%20https%3A%2F%2Fadrianrey.dev%20y%20quisiera%20trabajar%20contigo.",
  target: "_blank"
}
const _hoisted_13 = { class: "bio" }

import enUS from "@/locales/en-US";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default /*#__PURE__*/_defineComponent({
  __name: 'PresentationCard',
  setup(__props) {

const count = new enUS().aboutInfo.paragraphs.length;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t("aboutInfo.job")), 1),
      _hoisted_5,
      _hoisted_6,
      _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.$t("aboutInfo.links")) + ":", 1),
      _createElementVNode("h3", _hoisted_8, [
        _createElementVNode("a", _hoisted_9, [
          _createVNode(_unref(FontAwesomeIcon), { icon: ['fab', 'linkedin'] }),
          _createTextVNode(" LinkedIn ")
        ]),
        _createElementVNode("a", _hoisted_10, [
          _createVNode(_unref(FontAwesomeIcon), { icon: ['fab', 'square-instagram'] }),
          _createTextVNode(" Instagram ")
        ]),
        _createElementVNode("a", _hoisted_11, [
          _createVNode(_unref(FontAwesomeIcon), { icon: ['fab', 'square-x-twitter'] }),
          _createTextVNode(" X ")
        ]),
        _createElementVNode("a", _hoisted_12, [
          _createVNode(_unref(FontAwesomeIcon), { icon: ['fab', 'square-whatsapp'] }),
          _createTextVNode(" Whatsapp ")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("h1", null, "👋🏻 " + _toDisplayString(_ctx.$t("aboutMe")) + " 👨🏻‍💻", 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(count), (i) => {
        return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(_ctx.$t(`aboutInfo.paragraphs.${i - 1}`)), 1))
      }), 128))
    ])
  ]))
}
}

})